const getList = (state: AnyFixMe) => state.uploadedFonts.list;
const getQueue = (state: AnyFixMe) => state.uploadedFonts.queue;
const getUploadedItems = (state: AnyFixMe) => state.uploadedFonts.uploadedItems;
const getTimeOutTokens = (state: AnyFixMe) => state.uploadedFonts.timeOutTokens;

export { getList, getQueue, getUploadedItems, getTimeOutTokens };
